import { render, staticRenderFns } from "./new_prd.vue?vue&type=template&id=ddc72aa8&scoped=true&"
import script from "./new_prd.vue?vue&type=script&lang=js&"
export * from "./new_prd.vue?vue&type=script&lang=js&"
import style0 from "./new_prd.vue?vue&type=style&index=0&id=ddc72aa8&scoped=true&lang=less&"
import style1 from "./new_prd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc72aa8",
  null
  
)

export default component.exports